module.exports = {"pipeline":{"name":"pipeline-paragraph","title":"段落说明","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-paragraph/package.json
// module id = 562
// module chunks = 2